import { useEffect, useState } from "react";

const pad = (n) => (n > 9 ? String(n) : `0${n}`);

/**
 * Counts up from the moment this player started round 1, persisted in
 * localStorage so it survives navigation between rounds (mirrors the old
 * PHP app's `gettime{sessionId}{userId}` cookie that seeded every round's
 * timer without resetting). `extraSeconds` lets a round add a one-off
 * penalty (round 4's hint button) without touching the stored start time.
 */
export function useElapsedTimer(storageKey, extraSeconds = 0) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!storageKey) return undefined;
    let start = Number(localStorage.getItem(storageKey));
    if (!start) {
      start = Date.now();
      localStorage.setItem(storageKey, String(start));
    }
    const tick = () => setElapsed(Math.floor((Date.now() - start) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [storageKey]);

  const total = elapsed + extraSeconds;
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${pad(minutes)}:${pad(seconds)}`;
}

/** One-time initializer for the shared start-time key, used before the timer hook mounts (e.g. on the roadmap page). */
export function ensureTimerStarted(storageKey) {
  if (!storageKey) return;
  if (!localStorage.getItem(storageKey)) {
    localStorage.setItem(storageKey, String(Date.now()));
  }
}

export function useModakStorageKey(sessionId, userId) {
  return sessionId && userId ? `modak_start_${sessionId}_${userId}` : null;
}
